import { useExpressComponents } from '../../../hooks/useExpressComponents';
import { Seprator } from '@/components/Payment/Seprator';
import { SkeletonLoader } from '@/components/Common/SkeletonLoader';
import { useShouldBlockExpressCheckoutButtons } from '@/hooks/useShouldBlockExpressCheckoutButtons';

interface ExpressCheckoutRendererProps {
  onDisabledButtonClicked: () => void;
  blockedForZipCode: boolean;
  isZipCodeValid: boolean;
}

export const ExpressCheckoutRenderer = ({
  onDisabledButtonClicked,
  blockedForZipCode,
  isZipCodeValid,
}: ExpressCheckoutRendererProps) => {
  const { expressComponents, handleComponentReady, isAllComponentsLoaded, isComponentsAvailable } =
    useExpressComponents();
  const { shouldBlockExpressCheckoutButtons } = useShouldBlockExpressCheckoutButtons();

  if (expressComponents.length === 0) {
    return null;
  }

  return (
    <div data-testid="express-checkout-renderer" className="mt-3 md:mt-0 relative">
      {!isAllComponentsLoaded && (
        <div className="transition-opacity duration-300">
          <SkeletonLoader />
        </div>
      )}
      {shouldBlockExpressCheckoutButtons && !isZipCodeValid && (
        <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full z-50" onClick={onDisabledButtonClicked} />
      )}
      <div
        className={`flex flex-col gap-[18px] transition-opacity duration-300 ${!isAllComponentsLoaded ? 'opacity-0 absolute pointer-events-none' : 'opacity-100'} express-checkout-vertical`}
      >
        <div className="flex flex-col gap-2">
          {expressComponents.map(({ key, Component }) => (
            <Component key={key} isExpress onReady={(isAvailable: boolean) => handleComponentReady(key, isAvailable)} />
          ))}
        </div>
        {isComponentsAvailable && !blockedForZipCode && <Seprator />}
      </div>
    </div>
  );
};
